import _join from 'lodash/join';
import blush from './blush';
import eyelashes from './eyelashes.json';
import eyeliner from './eyeliner';
import eyeshadow from './eyeshadow';
import _throttle from 'lodash/throttle';

const OPEN_PREVIEWMODULE =
  'smb/components/webmodule/previewmodule/OPEN_PREVIEWMODULE';
const TOGGLE_ENABLED = 'smb/components/webmodule/previewmodule/TOGGLE_ENABLED';
const SWITCH_MODE = 'smb/components/webmodule/previewmodule/SWITCH_MODE';
const SWITCH_EYEWEAR_MODE =
  'smb/components/webmodule/previewmodule/SWITCH_EYEWEAR_MODE';
const SWITCH_HANDLE_TWO_MODULE =
  'smb/components/webmodule/previewmodule/HANDLE_TWO_MODULE';

const initialState = {
  isOpen: false,
  isEnabled: true,
  mode: 'photo',
  eyewearMode: 'photo',
  modelImage:
    'https://plugins-media.makeupar.com/webconsultation/images/makeup/image1.jpg',
  handleTwoModule: false,
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case OPEN_PREVIEWMODULE:
      return {...state, isOpen: true};
    case TOGGLE_ENABLED:
      return {...state, isEnabled: action.enabled};
    case SWITCH_MODE:
      return {...state, mode: action.newMode};
    case SWITCH_EYEWEAR_MODE:
      return {...state, eyewearMode: action.newMode};
    case SWITCH_HANDLE_TWO_MODULE:
      return {...state, handleTwoModule: action.newMode};
    default:
      return state;
  }
};

export function openPreviewModule() {
  return {
    type: OPEN_PREVIEWMODULE,
  };
}

export function toggleEnabled(enabled) {
  return {
    type: TOGGLE_ENABLED,
    enabled,
  };
}

export function switchModuleMode(newMode = 'photo') {
  window.YMK && window.YMK.isLoaded() && window.YMK.close();
  return {
    type: SWITCH_MODE,
    newMode,
  };
}

export function switchEyewearModuleMode(newMode = 'photo') {
  window.YMK && window.YMK.isLoaded() && window.YMK.close();
  return {
    type: SWITCH_EYEWEAR_MODE,
    newMode,
  };
}

export function switchHandleTwoModule(newMode) {
  window.YMK = null;
  return {
    type: SWITCH_HANDLE_TWO_MODULE,
    newMode,
  };
}

const throttledUpdateByValues = _throttle(
  values => {
    if (window.YMK && window.YMK.isLoaded()) {
      const skuItems = buildSkuItems(values);
      skuItems &&
        skuItems.forEach(skuItem =>
          window.YMK.applyMakeupBySkuItem(skuItem, 'manual-01-01')
        );
    }
  },
  100,
  {leading: false}
);

export function updateByValues(values) {
  throttledUpdateByValues(values);
  return {
    type: '',
  };
}

const buildSkuItems = values => {
  const lookPattern = values.lookPattern;
  if (!lookPattern) {
    const skuItem = buildSkuItem(values);
    return skuItem ? [skuItem] : [];
  }

  const skuItems = [];
  Object.values(lookPattern).forEach(sku => {
    let skuValues = {...sku};
    skuValues.color = sku.colors[0].color;
    skuValues.colorIntensity = sku.colors[0].colorIntensity;
    const skuItem = buildSkuItem(skuValues);
    if (skuItem) skuItems.push(skuItem);
  });
  return skuItems;
};

const buildSkuItem = values => {
  switch (values.skuType) {
    case 'EYESHADOW':
      return buildEyeShadow(values);
    case 'FOUNDATION':
      return buildFoundation(values);
    case 'LIPCOLOR':
      return buildLipColor(values);
    default:
      return buildBasic(values);
  }
};

const getSkuType = skuType => {
  switch (skuType) {
    case 'BLUSH':
      return 'blush';
    case 'EYELASHES':
    case 'MASCARA':
      return 'eye_lash';
    case 'EYESHADOW':
      return 'eye_shadow';
    case 'EYELINER':
      return 'eye_line';
    case 'FOUNDATION':
      return 'skin_toner';
    case 'LIPCOLOR':
      return 'lipstick';
    default:
      return skuType;
  }
};

const getPatterns = skuType => {
  switch (skuType) {
    case 'BLUSH':
      return blush;
    case 'EYELASHES':
    case 'MASCARA':
      return eyelashes;
    case 'EYESHADOW':
      return eyeshadow;
    case 'EYELINER':
      return eyeliner;
    case 'FOUNDATION':
    case 'LIPCOLOR':
    default:
      return [];
  }
};

const buildEyeShadow = values => {
  if (!values.colors || !values.colors.length || !values.patternGuid) {
    return;
  }
  return {
    sku: {
      skuGuid: 'manual-01',
      type: getSkuType(values.skuType),
    },
    patterns: getPatterns(values.skuType),
    items: [
      {
        skuItemName: '0',
        guid: 'manual-01-01',
        colors: {
          color: values.colors.map(c => '00' + c.color && c.color.substring(1)),
        },
        shimmer_intensities: {
          shimmer_intensity: values.colors.map(c => c.shimmerIntensity),
        },
        sku_guid: 'manual-01',
        patterns: {
          pattern_guid: [
            {
              content: values.patternGuid,
              color_intensities: _join(
                values.colors.map(c => c.colorIntensity),
                ','
              ),
            },
          ],
        },
      },
    ],
  };
};

const buildBasic = values => {
  if (!values.color || !values.patternGuid || values.colorIntensity == null) {
    return;
  }
  return {
    sku: {
      skuGuid: 'manual-01',
      type: getSkuType(values.skuType),
    },
    patterns: getPatterns(values.skuType),
    items: [
      {
        color_number: '01',
        guid: 'manual-01-01',
        colors: {
          color: '00' + values.color.substring(1),
        },
        sku_guid: 'manual-01',
        patterns: {
          pattern_guid: [
            {
              content: values.patternGuid,
              color_intensities: values.colorIntensity,
            },
          ],
        },
      },
    ],
  };
};

const buildLipColor = values => {
  if (!values.color || !values.patternGuid || values.colorIntensity == null) {
    return;
  }
  return {
    sku: {
      skuGuid: 'manual-01',
      type: getSkuType(values.skuType),
    },
    patterns: getPatterns(values.skuType),
    items: [
      {
        skuItemName: '0',
        color_number: '01',
        guid: 'manual-01-01',
        colors: {
          level_color: '643500' + values.color.substring(1),
        },
        sku_guid: 'manual-01',
        patterns: {
          pattern_guid: {
            content: values.patternGuid,
            shimmer_intensity: values.shimmerIntensity,
            shimmer_density: values.shimmerDensity,
            shimmer_color:
              values.shimmerColor && values.shimmerColor.substring(1),
            shimmer_granularity: values.shimmerGranularity,
            color_intensities: values.colorIntensity,
            gloss: values.glossIntensity,
          },
        },
      },
    ],
  };
};

const buildFoundation = values => {
  if (!values.color || values.colorIntensity == null) {
    return;
  }
  return {
    sku: {
      skuGuid: 'manual-01',
      type: getSkuType(values.skuType),
    },
    patterns: getPatterns(values.skuType),
    items: [
      {
        color_number: '01',
        guid: 'manual-01-01',
        content: '00' + values.color.substring(1),
        sku_guid: 'manual-01',
        intensity: values.colorIntensity,
      },
    ],
  };
};
